import { Box, Flex, Text } from '@chakra-ui/react'
import { RadioButtonLoading } from '@components/icons'
import React from 'react'

export const LoadingBlock = ({
  title,
  label
}: {
  title: string
  label: string
}) => {
  return (
    <Flex
      p="48px 32px"
      flexDirection="column"
      border="1px solid"
      borderColor="pale_gray"
      borderRadius="8px"
    >
      <Text textAlign="center" fontWeight="bold" mb="xxsmall">
        {title}
      </Text>
      <Text textAlign="center" color="#757575">
        This process could take up to 3 minutes
      </Text>
      <Box h="40px" />
      <Flex flexDirection="column" alignSelf="center" gap="16px">
        <Flex>
          <RadioButtonLoading />
          <Box w="8px" />
          <Text>{label}</Text>
        </Flex>
      </Flex>
    </Flex>
  )
}
